import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['subgroup', 'icon']

  static values = {
    menuHeights: { type: Object, default: {} },
    initIconClasses: {type: Array, default: [] },
    openMenuIconClasses: { type: Array, default: [] }
  }

  toggle(event) {
    event.preventDefault()
    const link = event.currentTarget
    this.currentGroup = this.subgroupTargets.find(subgroup => subgroup.parentElement === link.parentElement)
    this.currentIcon = this.iconTargets.find(icon => link.contains(icon))

    const computedHeight = window.getComputedStyle(this.currentGroup).height;

    (computedHeight === this.menuHeightsValue.out) ? this.show() : this.hide()
  }

  show() {
    this.currentIcon.classList.add(...this.openMenuIconClassesValue)
    this.currentGroup.style.height = this.currentGroup.scrollHeight + "px"

    const onTransitionEnd = () => {
      this.currentGroup.style.height = this.menuHeightsValue.in
      this.currentGroup.removeEventListener("transitionend", onTransitionEnd)
    }
    this.currentGroup.addEventListener("transitionend", onTransitionEnd)
  }

  hide() {
    this.currentIcon.classList.remove(...[...this.initIconClassesValue,...this.openMenuIconClassesValue])
    this.currentGroup.style.height = this.currentGroup.scrollHeight + "px"

    requestAnimationFrame(() => {
      this.currentGroup.style.height = this.menuHeightsValue.out
    })
  }
}
